import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../services.css'

const ios = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/apple.svg"
const android = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/android.svg"
const webApp = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/code-tag.svg"
const ml = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/algorithm.svg"
const cloud = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/brainstorm.svg"
const blockchain = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/cube.svg"
const ai = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/knowledge.svg"
const devops = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/share.svg"
const rpa = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/robotic-arm.svg"
const iot = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/virtual.svg"

const ServicesCards = () => {
    const services = [
        {
            icon: ios,
            alt: 'apple',
            title: 'IOS Mobile App Development',
            link: '/services/ios_app',
        },
        {
            icon: android,
            alt: 'android',
            title: 'Android Mobile App Development',
            link: '/services/android_app',
        },
        {
            icon: webApp,
            alt: 'web development',
            title: 'Web Application Development',
            link: '/services/web_app',
        },
        {
            icon: cloud,
            alt: 'cloud strategy',
            title: 'Cloud Strategy & Development',
            link: '/services/cloud_strategy',
        },
        {
            icon: blockchain,
            alt: 'blockchain',
            title: 'Blockchain Applications',
            link: '/services/blockchain_app',
        },
        {
            icon: rpa,
            alt: 'robotic process automation',
            title: 'Robotic Process Automation',
            link: '/services/robotic_process_automation',
        },
        {
            icon: iot,
            alt: 'iot',
            title: 'Internet Of Things (IoT)',
            link: '/services/iot_app',
        },
        {
            icon: ml,
            alt: 'machine learning',
            title: 'Machine Learning',
            link: '/services/machine_learning',
        },
        {
            icon: devops,
            alt: 'business intelligence',
            title: 'Business Intelligence',
            link: '/services/business_intelligence',
        },
        {
            icon: ai,
            alt: 'artificial intelligence',
            title: 'Artificial Intelligence',
            link: '/services/artificial_intelligence',
        },
    ];

    return (
        <Container>
            <Row>
                <Col xs={12}>
                    <h3 className="text-primary text-center mb-3 ft-wt-700">
                        How Can We Help You?
                    </h3>
                </Col>
            </Row>
            <Row className="row-cols-1 row-cols-md-2 row-cols-lg-4 row-cols-xl-5">
                {services.map((service, index) => (
                    <Col key={index} className="mb-3">
                        <Link to={service.link}>
                            <Card className="product-card">
                                <Card.Body className="text-center">
                                    <img className="mb-4" src={service.icon} alt={service.alt} />
                                    <p className="ft-wt-700">
                                        <Link to={service.link}>{service.title}</Link>
                                    </p>
                                    <h6 className="mb-0 mt-auto">
                                        <Link to={service.link}>Learn How</Link>
                                    </h6>
                                </Card.Body>
                            </Card>
                        </Link>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default ServicesCards;
